<template>
  <div class="product">
    <div class="image">
      <Picture :images="groupedProductImage" transparent />
    </div>
    <div class="info">
      <a :href="product.onlineStoreUrl" class="product-link">
        <h3 class="title">
          {{ product.title }}
        </h3>
      </a>
      <p class="price">
        {{
          $filters.toCurrency(
            product.priceRange.minVariantPrice.amount,
            product.priceRange.minVariantPrice.currencyCode,
            0
          )
        }}
      </p>
      <div class="input">
        <DropDown
          :options="dropdownVariants"
          default-label="Select size"
          @changed="handleVariantChange"
        />
        <div class="input__response">
          <ul>
            <li v-for="error of v$.selectedVariant.$errors" :key="error.$uid">
              {{ error.$message }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { unwrapNodes } from "@/helpers/graphql";
import Picture from "@/components/Picture.vue";
import { required, helpers } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import DropDown from "@/components/DropDown.vue";

export default {
  name: "SetProduct",
  components: {
    Picture,
    DropDown,
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  emits: ["variant-selected"],
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      selectedVariant: "",
    };
  },
  computed: {
    dropdownVariants() {
      return this.variants.map((variant) => {
        return {
          value: variant.id,
          label: variant.title,
          disabled: !variant.availableForSale,
          status: this.quantityStatus(variant.quantityAvailable),
        };
      });
    },
    groupedProductImage() {
      const standardImages = unwrapNodes(this.product.images?.edges)[0];
      const groupImage = this.product.groupedImage?.reference.image;

      return groupImage || standardImages;
    },
    variants() {
      return unwrapNodes(this.product.variants?.edges) || [];
    },
  },
  methods: {
    handleVariantChange(value) {
      this.selectedVariant = value;
      this.$emit("variant-selected", value);
    },
    quantityStatus(quantity) {
      if (quantity <= 0) {
        return "Out of stock";
      }
      if (quantity <= 15 && quantity > 5) {
        return "Low stock";
      }
      if (quantity <= 5) {
        return (
          quantity + " " + this.$filters.pluralize("item", quantity) + " left"
        );
      }
      return null;
    },
  },
  validations() {
    return {
      selectedVariant: {
        required: helpers.withMessage("Please select a variant", required),
      },
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/components/form";

.product {
  margin-bottom: 30px;

  &:last-child {
    margin-bottom: 0;
  }

  @include respond-above(md) {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    align-items: center;
    gap: 90px;
    margin-bottom: 0;
  }
}

.product-link {
  text-decoration: none;
}

.image {
  padding: 40px;

  @include respond-above(md) {
    padding: 50px;
  }
}

.title {
  @include t__editorial-headline-10;
  margin-bottom: 5px;
  display: inline-block;
}

.price {
  @include t__utility-label-30;
  margin-bottom: 20px;
}
</style>
